import {ScenarioPill} from '../scenario-pill/scenario-pill.jsx'
import styles from './scenario-card.module.scss'

/**
 * @param {{
 *   scenario: import('../../api/types.js').Scenario,
 *   active?: boolean
 * }} props
 */
export function ScenarioCard({scenario, active = false}) {
    const status = scenario.disabled ? 'Disabled' : (active ? 'Live' : 'Dormant')
    return (
        <article className={styles.card}>
            <header className={styles.header}>
                <p className={styles.type}>{scenario.type}</p>
                <ScenarioPill active={!scenario.disabled && active} label={status}/>
            </header>
            <h3 className={styles.name}>{scenario.name}</h3>
            {scenario.description && (
                <p className={styles.description}>{scenario.description}</p>
            )}
            <footer className={styles.footer}>
                <span className={styles.priority}>Priority {scenario.priority ?? 0}</span>
            </footer>
        </article>
    )
}
